// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyState_container__17hx-","heading":"EmptyState_heading__2GHaJ","body":"EmptyState_body__2zG9U"};